import React, { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useCurrentViewPropertySession } from 'src/hooks/use-current-view-property-session';
import { useRegisterReleaseHintReference } from '~containers/release-hint/use-register-release-hint-reference';
import { BasicAcademicYearFilled } from '~static/svg-components';
import { useGetAcademicYearTitle } from '~utils/use-academic-year';
import {
  contentHeaderSelectComponents,
  useContentHeaderSelectStyles,
} from './content-header-select-props';
import ContentHeaderSelectReadOnly from './content-header-select-read-only';

const getOptionValue = (option) => option?.id;
const getOptionLabel = (option) => option?.name;

const Control = forwardRef((props, ref) => (
  <contentHeaderSelectComponents.Control ref={ref} Icon={BasicAcademicYearFilled} {...props} />
));

function GroupAcademicYearSelect(props) {
  const { readOnly } = props;
  const { t } = useTranslation('academic-year');
  const [
    { currentViewAcademicYear, currentViewLandLord, currentViewLandlordAcademicYear },
  ] = useCurrentViewPropertySession();

  const getAcademicYearTitle = useGetAcademicYearTitle();

  const academicYearsGroupByActiveStatus = useMemo(() => {
    const academicYearsGroupByActiveStatus = [
      { label: t('active'), options: currentViewLandLord?.groupAcademicYears },
    ];
    return academicYearsGroupByActiveStatus;
  }, [currentViewLandLord?.groupAcademicYears, t]);

  const styles = useContentHeaderSelectStyles();

  const registerReleaseHintReference = useRegisterReleaseHintReference();

  return readOnly ? (
    <ContentHeaderSelectReadOnly
      Icon={BasicAcademicYearFilled}
      title={getAcademicYearTitle(currentViewAcademicYear.name)}
    />
  ) : (
    <div ref={registerReleaseHintReference('2021-05-01', 'academic-year-select')}>
      <Select
        components={{ ...contentHeaderSelectComponents, Control }}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        options={academicYearsGroupByActiveStatus}
        styles={styles}
        value={currentViewLandlordAcademicYear}
        {...props}
      />
    </div>
  );
}

export default GroupAcademicYearSelect;
